export default __webpack_public_path__ + "43dbf56e52c12cd4c833944d85170eec.svg";